import type { Dispatch, FC, SetStateAction } from 'react';
import { Flex } from '@eqi-investimentos/react';
import {
  ContentMode,
  ContentModeEnum,
  type Content,
} from '@/modules/Content/interface/Content';
import { VideoPlayer } from '@/components/sections/Player/VideoPlayer';
import { IfRender } from '@/utils/jsx';

export const ContentVideoMode: FC<ContentVideoModeProps> = ({
  authors,
  content,
  contentMode,
  progress,
  sendProgress,
  setContentMode,
}) => {
  return (
    <IfRender
      condition={contentMode === ContentModeEnum.VIDEO && !content.live_embed}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        w="full"
        bgColor="background.alwaysDark"
      >
        <Flex w="full" maxW="57rem" overflow="hidden">
          {content.video_urls?.default && (
            <VideoPlayer
              src={content.video_urls?.medium ?? content.video_urls?.default}
              srcHD={content.video_urls?.high ?? null}
              authors={authors}
              title={content.title}
              autoPlay
              nextSlug={content.next_content}
              previousSlug={content.previous_content}
              progress={progress}
              sendWatchProgress={sendProgress}
              hasAudioMode={content.has_audio}
              setAudioMode={() => setContentMode(ContentModeEnum.AUDIO)}
              hasTextMode={content.has_text}
              setTextMode={() => setContentMode(ContentModeEnum.TEXT)}
              isContentPage
            />
          )}
        </Flex>
      </Flex>
    </IfRender>
  );
};

type ContentVideoModeProps = {
  authors: string;
  content: Content;
  contentMode: ContentMode;
  progress: number;
  sendProgress: (progress: number, duration: number) => Promise<void>;
  setContentMode: Dispatch<SetStateAction<ContentMode>>;
};
